export const triggerHaptic = () => {
  // no-op
}
